var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "21px",
    viewBox: "0 0 17 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uE9A8 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multiple",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "39-40-Multiple-Add-Saved-batches-Copy-2",
    transform: "translate(-338.000000, -794.000000)",
    fill: "#FFCC00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.465144,801.344952 L353.295673,801.344952 L347.465144,795.564904 L347.465144,801.344952 Z M340.120192,794 L348.550481,794 L354.860577,800.310096 L354.860577,812.930288 C354.860577,813.502407 354.650242,813.990383 354.229567,814.394231 C353.808892,814.798079 353.312503,815 352.740385,815 L340.120192,815 C339.548074,815 339.051685,814.798079 338.63101,814.394231 C338.210334,813.990383 338,813.502407 338,812.930288 L338.050481,796.069712 C338.050481,795.497593 338.252402,795.009617 338.65625,794.605769 C339.060098,794.201921 339.548074,794 340.120192,794 Z",
    id: "\\uE9A8-copy"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.d562c44854f6e274e7f7d7496c57f23c.svg";
export { ForwardRef as ReactComponent };